<template>
    <TrimInfoModal
            :modalTitle="'Add new trim'"
            :btnSubmitTitle="'Add trim'"
            :sendStatus="dataSendStatus"
            :isCreateNew="true"
            :isDuplicate="false"
            :isEdit="false"
            @formSubmit="createNewTrim"
    ></TrimInfoModal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import TrimInfoModal from "./TrimInfoModal";
    
    export default {
        name: "CreateNewTrimModal",
        
        components: {
            TrimInfoModal,
        },

        emits: [
            'newTrimWasAdded',
        ],

        data() {
            return {
                dataSendStatus: false,
            }
        },

        computed: {
            ...mapGetters('trims', [
                'getTrimNameAsUrl',
            ]),

        },

        methods: {
            ...mapActions('trims', [
                'addNewTrim',
            ]),

            async createNewTrim(trimData) {
                this.dataSendStatus = true;

                let description = trimData.description;
                let isSmallTrim = trimData.isSmallTrim;
                let points = [];
                let paintColorId = null;
                let paintSide = true;

                let trim = {
                    description,
                    isSmallTrim,
                    points,
                    paintColorId,
                    paintSide,
                };

                // need to check if the name is free
                let newAddedTrim = await this.addNewTrim(trim)
                    .finally(() => {
                        this.dataSendStatus = false;
                    });

                // trimId in the route path is used for identify the trim by the route url
                const trimId = newAddedTrim['id'];
                const trimName = newAddedTrim['trimName'];

                // for use the trimId and trimName in the route path is need to convert it in the url format
                const trimNameAsUrl = this.getTrimNameAsUrl(trimId, trimName);

                // navigate to the Editor page
                this.$router.push({ name: 'editor', params: { trimName: trimNameAsUrl } });

                this.$emit('newTrimWasAdded');
            },

        },

    }
</script>

<style scoped>

</style>